import produce from 'immer';
import { createAlert } from '../../../alert.js?vue3';
import { __, sprintf } from '~/locale';
import { observable } from '../../../lib/utils/observable.js?vue3';
import { Tracking } from '../../constants';
import { confidentialityQueries } from '../../queries/constants';
import SidebarEditableItem from '../sidebar_editable_item.vue?vue3';
import SidebarConfidentialityContent from './sidebar_confidentiality_content.vue?vue3';
import SidebarConfidentialityForm from './sidebar_confidentiality_form.vue?vue3';
export const confidentialWidget = observable('sidebar_confidential_widget', {
    setConfidentiality: null
});
const hideDropdownEvent = new CustomEvent('hiddenGlDropdown', {
    bubbles: true
});
export default {
    name: 'SidebarConfidentialityWidget',
    tracking: {
        event: Tracking.editEvent,
        label: Tracking.rightSidebarLabel,
        property: 'confidentiality'
    },
    components: {
        SidebarEditableItem,
        SidebarConfidentialityContent,
        SidebarConfidentialityForm
    },
    inject: {
        isClassicSidebar: {
            default: false
        }
    },
    props: {
        iid: {
            type: String,
            required: true
        },
        fullPath: {
            type: String,
            required: true
        },
        issuableType: {
            required: true,
            type: String
        }
    },
    emits: [
        'close-form',
        'expand-sidebar'
    ],
    data () {
        return {
            confidential: false
        };
    },
    apollo: {
        confidential: {
            query () {
                return confidentialityQueries[this.issuableType].query;
            },
            variables () {
                return {
                    fullPath: this.fullPath,
                    iid: String(this.iid)
                };
            },
            update (data) {
                return data.namespace?.issuable?.confidential || false;
            },
            skip () {
                return !this.iid;
            },
            error () {
                createAlert({
                    message: sprintf(__('Something went wrong while setting %{issuableType} confidentiality.'), {
                        issuableType: this.issuableType
                    })
                });
            }
        }
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.confidential.loading;
        }
    },
    mounted () {
        confidentialWidget.setConfidentiality = this.setConfidentiality;
    },
    destroyed () {
        confidentialWidget.setConfidentiality = null;
    },
    methods: {
        closeForm () {
            this.$refs.editable.collapse();
            this.$el.dispatchEvent(hideDropdownEvent);
            this.$emit('close-form');
        },
        // synchronizing the quick action with the sidebar widget
        // this is a temporary solution until we have confidentiality real-time updates
        setConfidentiality () {
            const { defaultClient: client } = this.$apollo.provider.clients;
            const sourceData = client.readQuery({
                query: confidentialityQueries[this.issuableType].query,
                variables: {
                    fullPath: this.fullPath,
                    iid: this.iid
                }
            });
            const data = produce(sourceData, (draftData)=>{
                draftData.namespace.issuable.confidential = !this.confidential;
            });
            client.writeQuery({
                query: confidentialityQueries[this.issuableType].query,
                variables: {
                    fullPath: this.fullPath,
                    iid: this.iid
                },
                data
            });
        },
        expandSidebar () {
            this.$refs.editable.expand();
            this.$emit('expand-sidebar');
        }
    }
};
